import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    input,
    output,
} from '@angular/core';
import { TelXLAvatarComponent } from '@dxp/elements';
import {
    IDirectoryListing,
    IDirectoryListingSelection,
    IDirectoryListingEvent,
} from '@dxp/core/models';
import { FormatDurationPipe } from '@dxp/core/pipes';
import { AvatarVariant, ListingMode } from '@dxp/core/types';

@Component({
    selector: 'telxl-shared-directory-listing-ivr-item',
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CommonModule, TelXLAvatarComponent],
    providers: [FormatDurationPipe],
    templateUrl: './directory-listing-ivr-item.component.html',
    styleUrl: './directory-listing-ivr-item.component.scss',
})
export class TelXLDirectoryListingIvrItemComponent {
    mode = input<ListingMode[]>([]);
    source = input.required<AvatarVariant>();
    item = input.required<IDirectoryListing>();
    selected = input<IDirectoryListingSelection>({
        selected: false,
        item: ['voice'],
    });
    disabled = input<boolean>(false);
    selectedChange = output<IDirectoryListingEvent>();

    select() {
        if (this.disabled()) return;

        this.selectedChange.emit({ type: 'voice', item: this.item() });
    }
}
